// @ts-strict-ignore
import { component } from "picoapp";

export const accordionGroup = component((node: HTMLElement) => {
  const accordionButtons = node.querySelectorAll<HTMLButtonElement>(
    ".js-accordion-button"
  );

  const handleAccordionToggle = function (
    e: MouseEvent & { currentTarget: (typeof accordionButtons)[number] }
  ) {
    if (e.currentTarget?.parentElement?.dataset.isOpen === "true") {
      const otherAccordionButtons = Array.from(accordionButtons).filter(
        (element) => element !== e.currentTarget
      );
      otherAccordionButtons.forEach((button) => {
        if (button.parentElement?.dataset.isOpen === "true") {
          button.dispatchEvent(new Event("tbsp:close-accordion"));
        }
      });
    }
  };

  accordionButtons.forEach((button) =>
    button.addEventListener("click", handleAccordionToggle)
  );

  return () => {
    accordionButtons.forEach((button) =>
      button.removeEventListener("click", handleAccordionToggle)
    );
  };
});
